import { Luma } from './Luma';

export function BlackOrWhite(color, opposite) {
  var d = document.createElement('div');
  d.style.color = color;
  document.body.appendChild(d);
  //Color in RGB
  var color = window.getComputedStyle(d).color;
  document.body.removeChild(d);
  var rgb = color.split(',');
  var r = parseInt(rgb[0].replace(/\D/g, ''));
  var g = parseInt(rgb[1].replace(/\D/g, ''));
  var b = parseInt(rgb[2].replace(/\D/g, ''));
  var luma = Luma(r, g, b);
  let black = luma < 66.6;
  if (opposite) black = !black;
  return black ? 'black' : 'white';
}
